import type { SpecialGroupType } from '../../types/GroupsArrayType';
import type { EventFilterType } from '../../types';
import { UNASSIGNED, AVAILABLE } from '../constants';

export default function isSpecialGroupVisible(
  type: SpecialGroupType,
  eventTypesFilter: Array<EventFilterType>
): boolean {
  if (!eventTypesFilter.length) {
    return true;
  }

  return type === UNASSIGNED
    ? eventTypesFilter.includes(UNASSIGNED)
    : eventTypesFilter.includes(AVAILABLE);
}
